/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React from "react";
import { defaultTheme, Provider } from "@adobe/react-spectrum";
import classNames from "classnames";
import AdobeLogo from "icons/AdobeIcon.svg";
import IconCSS from "icons/Icon.css";

const AdobeIcon = () => (
    <Provider colorScheme="light" theme={ defaultTheme }>
        <div className={ classNames(IconCSS.icon, IconCSS.iconSideMenu) }>
            <AdobeLogo style={ {
                fill: "#6e6e6e",
            } }
            />
        </div>
    </Provider>
);

export default AdobeIcon;
